const Requisitos = () => <div className="page-content">Requisitos Content</div>;

export default Requisitos;
